import React, { useEffect, useState } from "react";
import { cross } from "../../../images/icon";
import { getTrayTitle } from "../../modules/TrayModules/Helper/helper";
import ContainerHOC from "../Checkout01/ContainerHOC";
import { subscribeHBAModal } from "../Events/hba.events";
import { publishMonetisationcontinue } from "../Events/monetisation.events";
import { publishAppLoading, publishErrorUpdate, publishUserCreated } from "../Events/utils.events";
import { requestLocation } from "./helper";
import "./style.scss"
import { ANALYTICSEVENTS } from "../LoginV2/Helpers/analyticsMap";
import pubsub from "@viewlift/pubsub";
import { fetchCurrentPlan } from "../PlansWrapper/helper";
import { flowSteps} from "../helper";
import { fetchUserObject } from "../MonetisationModule02/Stripe/helper";
import { dynamicConfig } from "../../components/DynamicRoutes";
import { useNavigate } from "react-router-dom";
import { fetchUserData } from "../../helpers";
import Cookies from "js-cookie";

const GetGeoLocation = (module) => {
    let checkoutMetaData = module?.checkoutMetaData
    let moduleData = module?.moduleData
    let metadataMap = moduleData?.metadataMap
    let layoutSettings = moduleData?.layout?.settings
    let continueWithoutSubscription = module?.continueWithoutSubscription

    const navigate = useNavigate()
    const [showHBAModal, setShowHBAModal] = useState(false)
    const [showNoAccess, setShowNoAccess] = useState(false)

    const handleHBAModal = (data) => {
        setShowHBAModal(data)
    }

    useEffect(() => {
        subscribeHBAModal(handleHBAModal)
    }, [])
    const handleSkipHba = () => {
        publishAppLoading(true)
        publishMonetisationcontinue(true)
    }

    const onContinueWithoutSubscription = () => {
        try {
            const res = fetchUserObject();
            if(res) {
                fetchUserData().then(async () => {
                    Cookies.set("without-subscription", true)
                    publishUserCreated({ status: status ? true : false })
                    publishAppLoading(false)
                    let nextRoute = await dynamicConfig(null, window.location.pathname, true)
                    updateUserBeacon()
                    navigate(nextRoute)
                }).catch((e) => {
                    console.log(e)
                })
            }
        }catch(err) {
            publishErrorUpdate("Error while creating account", err)
            publishAppLoading(false)
        }
    }

    const updateUserBeacon = () => {
        let plan = fetchCurrentPlan()
        const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
        let eventData = {
            "pageUrl": checkoutInitPageDetails?.pageUrl,
            "monetizationType": plan?.type,
            "stepsCompleted": flowSteps,
            "message": "user clicked on continue without subscription"
        }
        pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_CANCELED, data: eventData});
    }

    return (<>
        {showHBAModal && !showNoAccess ? <div className="geo-location-container">
            <div style={{ backgroundColor: layoutSettings?.moduleBackgroundColor }} className="share-location-wrapper">
                <div className="cancel-cross" onClick={() => setShowHBAModal(false)}>{cross()}</div>
                <h4 className="title">{metadataMap?.confirmLocationText}</h4>
                <p className="description"> {metadataMap?.shareLocationDescription}
                </p>
                <button aria-label="Share Location" className="action-btn bg-color" style={{ backgroundColor: layoutSettings?.CTABgColor }} onClick={() => requestLocation(setShowNoAccess)} data-test="request-location-btn">{metadataMap?.shareLocationText}</button>
                {continueWithoutSubscription ? <p onClick={() => {onContinueWithoutSubscription()}} className="without-subscription-tag" data-test="without-subscription-btn">{metadataMap?.withoutSubscriptionText || 'Continue without a subscription'}</p> : null}
            </div>
        </div> : <></>}
        {showHBAModal && showNoAccess ? <div className="geo-location-container">
            <div style={{ backgroundColor: layoutSettings?.moduleBackgroundColor }} className="share-location-wrapper">
                <div className="cancel-cross" onClick={() => setShowHBAModal(false)}>{cross()}</div>
                <div className='title'>{checkoutMetaData?.noPlansHeading || "There are no plans in your area"}</div>
                <div className='description' dangerouslySetInnerHTML={{ __html: getTrayTitle(checkoutMetaData?.noPlansBody) }} />
                <button aria-label="Continue" className="action-btn site-cta-background-color" onClick={() => handleSkipHba()}>{checkoutMetaData?.noPlansContinueText || 'Continue'}</button>
                {continueWithoutSubscription ? <button aria-label="Continue without a subscription" onClick={() => {onContinueWithoutSubscription()}} className="action-btn bg-color">{metadataMap?.withoutSubscriptionText || `Continue without a subscription`}</button> : null}
            </div>
        </div> : <></>}
    </>);
};

export default ContainerHOC(GetGeoLocation);
